import { render, staticRenderFns } from "./_drawer_01.vue?vue&type=template&id=3b65b843"
import script from "./_drawer_01.vue?vue&type=script&lang=js"
export * from "./_drawer_01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports